import { render, staticRenderFns } from "./MasterClocks.vue?vue&type=template&id=bf2dbd9a&"
import script from "./MasterClocks.vue?vue&type=script&lang=js&"
export * from "./MasterClocks.vue?vue&type=script&lang=js&"
import style0 from "./MasterClocks.vue?vue&type=style&index=0&id=bf2dbd9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports